import { render } from "./SearchResultsItem.vue?vue&type=template&id=21f2d158&scoped=true"
import script from "./SearchResultsItem.vue?vue&type=script&lang=js"
export * from "./SearchResultsItem.vue?vue&type=script&lang=js"

import "./SearchResultsItem.vue?vue&type=style&index=0&id=21f2d158&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f2d158"]])

export default __exports__